import cn from 'classnames';
import { PropsWithChildren } from 'react';

import { CrossListItem } from 'src/types/components';

import Link from 'components/BaseHelpers/Link';
import Text from 'components/BaseHelpers/Text';

import ActionIcon from '../ActionIcon';
import { IconType } from '../ActionIcon/ActionIcon';
import RichText from '../RichText';

import styles from './CrossLink.module.scss';

export type CrossLinkProps = CrossListItem & {
  type?: 'small' | 'large';
};

type DivWrapperProps = {
  className?: string;
};

const DivWrapper = (props: PropsWithChildren<DivWrapperProps>): JSX.Element => (
  <div className={props.className}>{props.children}</div>
);

const CrossLink = ({ heading, eyebrow, description, url, type }: CrossLinkProps): JSX.Element => {
  const isExternal = url?.target === '_blank';
  const isLargeCard = type === 'large';

  const hasLink = url?.href;

  const LinkOrDiv = hasLink ? Link : DivWrapper;

  let iconType: IconType = isLargeCard ? 'long' : 'standard';
  if (url?.href.includes('tel:')) {
    iconType = 'telephone';
  } else if (url?.href.includes('mailto:')) {
    iconType = 'email';
  }

  return (
    <LinkOrDiv {...url} className={cn(styles.crosslink, isLargeCard && styles['crosslink--large'])}>
      {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
      <Text field={heading} className={styles.title} />
      <RichText field={description} className={styles.heading} styleType="p3" />
      {hasLink && (
        <ActionIcon
          wrapperClass={styles.iconWrapper}
          type={iconType}
          className={cn(
            styles.icon,
            isExternal && styles.iconExternal,
            styles[`icon--${iconType}`]
          )}
          aria-hidden
          external={isExternal}
        />
      )}
    </LinkOrDiv>
  );
};

export default CrossLink;
